<template>
  <div class="tags">
    <el-tag size="small" :type="hoursTotalThisLastWeek.totalThisWeekClass">
      <span>This{{ this.size === 'small' ? '' : ' week' }}:</span>
      <icon name="regular/clock" />
      <span>{{ hoursTotalThisLastWeek.totalThisWeek }}</span>
    </el-tag>
    <el-tag size="small" :type="hoursTotalThisLastWeek.totalLastWeekClass">
      <span>Last{{ this.size === 'small' ? '' : ' week' }}:</span>
      <icon name="regular/clock" />
      <span>{{ hoursTotalThisLastWeek.totalLastWeek }}</span>
    </el-tag>
  </div>
</template>

<script>
  import moment from 'moment'
  import { mixin as LogTimes } from '../../mixins/LogTimes'

  export default {
    name: 'week-total-tags',
    mixins: [LogTimes],
    components: {},
    props: {
      size: {
        default: 'large'
      },
      user: {
        default: null
      }
    },
    data () {
      return {
        startDateLastWeek: moment().subtract(1, 'week').day(1).hour(0).minute(0).second(0).utc(),
        endDateLastWeek: moment().subtract(1, 'week').day(7).hour(23).minute(59).second(59).utc(),

        startDateThisWeek: moment().day(1).hour(0).minute(0).second(0).utc(),
        endDateThisWeek: moment().day(7).hour(23).minute(59).second(59).utc()
      }
    },
    computed: {
      hoursTotalThisLastWeek () {
        // Total time logged this week by the current user
        let totalThisWeek = 0
        let totalLastWeek = 0

        let totalThisWeekClass = 'primary'
        let totalLastWeekClass = 'success'

        if (this.user) {
          Object.keys(this.logs).map((k) => {
            if (this.logs[k].end !== null && this.logs[k].user_id === this.user.id) { // Ignore running logs
              let logTimestamp = moment.utc(this.logs[k].end).unix()
              if (logTimestamp >= this.startDateLastWeek.unix() && logTimestamp <= this.endDateLastWeek.unix()) {
                totalLastWeek += this.logTimeInSeconds(this.logs[k])
              } else if (logTimestamp >= this.startDateThisWeek.unix() && logTimestamp <= this.endDateThisWeek.unix()) {
                totalThisWeek += this.logTimeInSeconds(this.logs[k])
              }
            }
          })
        }

        // We want to hit a target of 30hrs each week

        // Last week we just count the hours for the entire week
        if ((totalLastWeek / 60 / 60) < 15) {
          totalLastWeekClass = 'danger'
        } else if ((totalLastWeek / 60 / 60) < 30) {
          totalLastWeekClass = 'warning'
        }

        return {
          totalThisWeek: this.secondsToTime(totalThisWeek),
          totalLastWeek: this.secondsToTime(totalLastWeek),
          totalThisWeekClass,
          totalLastWeekClass
        }
      },

      // Vuex Mappings
      logs () {
        return this.$store.state.logs.objects
      }
    },
    methods: {
      getLastWeekLogs () {
        let query = {
          'user_id': this.user.id,
          'start': this.startDateLastWeek.toISOString(),
          'end': this.endDateLastWeek.toISOString()
        }
        this.$store.dispatch('getLogs', query)
      },
      getThisWeekLogs () {
        let query = {
          'user_id': this.user.id,
          'start': this.startDateThisWeek.toISOString(),
          'end': this.endDateThisWeek.toISOString()
        }
        this.$store.dispatch('getLogs', query)
      }
    },
    mounted () {
      if (this.user) {
        // Delay the API requests to speed up rendering
        setTimeout(function () {
          this.getLastWeekLogs()
          this.getThisWeekLogs()
        }.bind(this), 1000)
      }
    },
    watch: {
      'user' () {
        if (this.user) {
          this.getLastWeekLogs()
          this.getThisWeekLogs()
        }
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less" scoped>
  .tags {
    margin-left: 10px;
    display: inline-block;
    vertical-align: top;

    .fa-icon {
      margin: 0 4px;
    }
    .fa-icon,
    span {
      display: inline-block;
      vertical-align: middle;
    }
  }
</style>
